import React from 'react';
import './custom-range-input.scss';

interface RangeValueType {
  label: string;
  name: string;
  value: string;
  valueType: string;
  onChange: (name:string, value: string | number) => void;
  min: number;
  max: number;
  step?: number;
}

/**
 * Custom Range Input Component
 * @returns
 */
function CustomRangeInput({ label, name, value, valueType, onChange, min, max, step }: RangeValueType) {

  /**
   * Handling Event Values
   * @param value 
   */
  const handleValueChange = (changeValue: string | number) => {
    onChange(name, changeValue);
  }

  return (
    <div className="range-input-wrap">
      <div className="font-size">
        <p>{label}</p>
        <p>{`${value} ${valueType}`}</p>
      </div>
      <div className="range-input">
        <input type="range" onChange={(event)=>handleValueChange(event.target.value)} min={min} max={max} name={name} value={value} step={step} />
      </div>
    </div>
  );
}

CustomRangeInput.defaultProps = {
  step: null
}

export default CustomRangeInput;
